export default __webpack_public_path__ + "img/arrowdown.89f0749.svg";